import React from 'react';
import { NumericFormat } from 'react-number-format';

type Props = {
  value: string | number;
  /**
   * Fires on every value change. The optional `source` argument tells the
   * caller whether the change came from a user interaction (`'event'`)
   * or from `react-number-format` re-normalising the `value` prop on
   * mount / re-render (`'prop'`). Use it when the caller wants to skip
   * side effects (e.g. "user acknowledged this field") that should only
   * fire for genuine user input.
   */
  onChangeValue: (v: string, source?: 'event' | 'prop') => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  decimalScale?: number;
  disabled?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
};

export function AmountInput({
  value,
  onChangeValue,
  placeholder,
  className,
  style,
  decimalScale = 2,
  disabled = false,
  onFocus,
  onBlur,
}: Props) {
  return (
    <NumericFormat
      value={value}
      valueIsNumericString
      thousandSeparator="."
      decimalSeparator=","
      allowedDecimalSeparators={[',', '.']}
      decimalScale={decimalScale}
      fixedDecimalScale={false}
      allowNegative={false}
      inputMode="decimal"
      placeholder={placeholder}
      className={className}
      style={style}
      disabled={disabled}
      onValueChange={(vals, sourceInfo) => {
        onChangeValue(vals.value, sourceInfo.source);
      }}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
}
